import { baseApi, SESSION_TAG, WISHLIST_TAG } from 'shared/api'
import { mapSession } from '../lib/mapSession'
import { mapUser } from '../lib/mapUser'
import { mapHistoryLog } from '../lib/mapHistoryLog'
import { type User, type Session } from '../model/types'
import { type UserDto, type RequestLoginBody, type SessionDto } from './types'

export const sessionApi = baseApi.injectEndpoints({
  endpoints: build => ({
    login: build.mutation<Session, RequestLoginBody>({
      query: body => ({
        url: `lead/lead-login`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [SESSION_TAG, WISHLIST_TAG],
      transformResponse: (response: SessionDto) => mapSession(response),
    }),
    me: build.query<User, void>({
      query: () => ({
        url: `lead/me`,
      }),
      providesTags: [SESSION_TAG],
      transformResponse: (response: UserDto) => mapUser(response.data),
    }),
    logout: build.query<User, void>({
      query: () => ({
        url: `lead/me/logout`,
        method: 'POST',
      }),
    }),
    auto_login: build.mutation<Session, string>({
      query: hash => ({
        url: `lead/secured-auto-login?token=${hash}`,
        method: 'GET',
      }),
      transformResponse: (response: SessionDto) => mapSession(response),
    }),
    logHistory: build.query<Session, string>({
      query: () => ({
        url: 'cfd/get-logs',
        method: 'GET',
      }),
      transformResponse: (response: SessionDto) => mapHistoryLog(response),
    }),

    chartConfig: build.query<Session, string>({
      query: () => ({
        url: 'chart/config',
        method: 'GET',
      }),
    }),

    chartHistory: build.query<Session, string>({
      query: params => ({
        url: 'chart/history',
        method: 'GET',
        params,
      }),
    }),

    chartSymbol: build.query<Session, string>({
      query: params => ({
        url: 'chart/symbols',
        method: 'GET',
        params,
      }),
    }),
    chartTime: build.query<Session, string>({
      query: () => ({
        url: 'chart/time',
        method: 'GET',
      }),
    }),
    chartSearch: build.query<Session, string>({
      query: params => ({
        url: `chart/search?limit=30&query=${params.userInput}&type=${params.symbolType}&exchange=${params.exchange}`,
        method: 'GET',
      }),
    }),

    // https://demo_feed.tradingview.com/search?limit=30&query=AAPL&type=&exchange=

    changePassword: build.mutation<Session, string>({
      query: body => ({
        url: 'lead/me/change-password',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const {
  useLoginMutation,
  useMeQuery,
  useLogHistoryQuery,
  useChangePasswordMutation,
  useChartConfigQuery,
  useChartHistoryQuery,
  useChartSymbolQuery,
  useChartTimeQuery,
} = sessionApi
